/* eslint-disable no-extend-native, no-unused-vars */
let isShowLog = false
/**
 * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
 * 可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) * eg: * (new
 * Date()).Format("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
 * (new Date()).Format("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).Format("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).Format("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
Date.prototype.Format = function (fmt) {
  let o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  let week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[this.getDay() + ''])
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  if (isShowLog) {
    console.log('extendDate -> Format', fmt)
  }
  return fmt
}

/**
 * @param date
 * @returns {number}
 * 如果指定的数与参数相等返回 0。
 * 如果指定的数小于参数返回  -1。
 * 如果指定的数大于参数返回   1。
 * 参数为空时返回          -2。
 * @constructor
 */
Date.prototype.Compare = function (date) {
  if (!date) return -2
  let isDate = false
  if (date instanceof Date) isDate = true
  if (!isDate) {
    let timeStamp = Number(date)
    let isInteger = Number.isInteger(timeStamp)
    if (isInteger) date = new Date(timeStamp)
    else date = new Date(date)
  }
  if (!date) return -2
  if (this.getFullYear() > date.getFullYear()) return 1
  if (this.getFullYear() === date.getFullYear()) {
    if (this.getMonth() > date.getMonth()) return 1
    if (this.getMonth() === date.getMonth()) {
      if (this.getDate() > date.getDate()) return 1
      if (this.getDate() === date.getDate()) return 0
      else return -1
    } else return -1
  } else return -1
}

/**
 * 获取时间部分
 * @param isCutS 去掉秒为:true, 否则为:false
 * @returns {string}
 * @constructor
 */
Date.prototype.ToHmsString = function (isCutS) {
  let h = this.getHours()
  let m = this.getMinutes()
  let s = this.getSeconds()
  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  if (isCutS) {
    if (s < 30) {
      return h + ':' + m
    } else if (m === 59) {
      return ++h + ':00'
    } else {
      return h + ':' + ++m
    }
  } else {
    return h + ':' + m + ':' + s
  }
}

/**
 * 时间部分的比较
 * 大于：1
 * 相等：0
 * 小于：-1
 * @param date
 * @constructor
 */
Date.prototype.HmsCompareTo = function (date) {
  let h, m, s, arg0, arg1
  h = this.getHours()
  m = this.getMinutes()
  s = this.getSeconds()
  arg0 = (h * 60 + m) * 60 + s
  h = date.getHours()
  m = date.getMinutes()
  s = date.getSeconds()
  arg1 = (h * 60 + m) * 60 + s

  let flag = arg0 > arg1 ? 1 : arg0 === arg1 ? 0 : -1

  if (isShowLog) {
    console.log('extendDate -> HmsCompareTo', arg0, arg1, flag)
  }
  return flag
}

// /**
//  * @param count
//  * @constructor
//  * @return
//  * 返回一个年份增加了 count 年的 date 对象
//  */
// Date.prototype.YearIncrement = function (count) {
//   return new Date(this.getFullYear() + count, this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds())
// }
/**
 * 此方法还有毛病，不要使用
 * "*******************东区时间************************************";
 * "零时区-伦敦时间：" + getLocalTime(0);
 * "东一区-柏林时间：" + getLocalTime(1);
 * "东二区-雅典时间：" + getLocalTime(2);
 * "东三区-莫斯科时间：" + getLocalTime(3);
 * "东四区-时间：" + getLocalTime(4);
 * "东五区-伊斯兰堡时间：" + getLocalTime(5);
 * "东六区-科伦坡时间：" + getLocalTime(6);
 * "东七区-曼谷时间：" + getLocalTime(7);
 * "东八区-北京时间：" + getLocalTime(8);
 * "东九区-东京时间：" + getLocalTime(9);
 * "东十区-悉尼时间：" + getLocalTime(10);
 * "东十二区-斐济时间：" + getLocalTime(12);
 * "*******************西区时间************************************");
 * "西十区-斐济时间：" + getLocalTime(-10);
 * "西九区-阿拉斯加时间：" + getLocalTime(-9);
 * "西八区-太平洋时间（美国和加拿大）：" + getLocalTime(-8);
 * "西七区-山地时间（美国和加拿大）：" + getLocalTime(-7);
 * "西六区-中部时间（美国和加拿大）：" + getLocalTime(-6);
 * "西五区-东部时间（美国和加拿大）：" + getLocalTime(-5);
 * "西四区-大西洋时间（加拿大）：" + getLocalTime(-4);
 * "西三区-巴西利亚时间：" + getLocalTime(-3);
 * @param td  时间差：time difference
 * @param isShowLog 是否打印log
 * @constructor
 */
// Date.prototype.GetUTCTime = function (td) {
//   if (typeof td !== 'number' || td === undefined) td = 0
//   let d = new Date()
//   // 得到1970年一月一日到现在的秒数
//   let len = d.getTime()
//   // 本地时间与GMT时间的时间偏移差
//   let offset = d.getTimezoneOffset() * 60000
//   // 得到现在的格林尼治时间
//   let utcTime = len + offset
//
//   if (isShowLog) {
//     console.log('extendDate -> GetUTCTime', utcTime)
//   }
//
//   return new Date(utcTime + 3600000 * td).getTime()
// }



// WEBPACK FOOTER //
// ./src/utils/dateExtend.js